import React, { useRef } from "react";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Table } from "react-bootstrap";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ScrambleText from "../utils/ScrambleText";
const utahData = "/img/headerlogo.png";
const bodex = "/img/bodexLogo.png";
const kpi = "/img/KPI-DASH 2.png";
const pdf = "/img/pdf1.png";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const CsAndItTable1 = ({ data }) => {
  const pdfRef = useRef();

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  const years = data.map((item) => item.year);
  const employment_14_18 = data.map((item) => parseInt(item.age_14_18));
  const employment_22_24 = data.map((item) => parseInt(item.age_22_24));
  const yoyChange_14_18 = data.map((item) =>
    item.yoy_change_14_18 ? parseFloat(item.yoy_change_14_18) : null
  );
  const yoyChange_22_24 = data.map((item) =>
    item.yoy_change_22_24 ? parseFloat(item.yoy_change_22_24) : null
  );

  const chartData = {
    labels: years,
    datasets: [
      {
        label: "Employment (14-18)",
        data: employment_14_18,
        backgroundColor: "rgba(135, 206, 250, 0.8)", // Soft Blue
        borderColor: "rgba(100, 149, 237, 1)",
        borderWidth: 1,
        type: "bar",
        yAxisID: "y-axis-count",
      },
      {
        label: "Employment (22-24)",
        data: employment_22_24,
        backgroundColor: "#F9CCCC", // Soft Green
        borderColor: "#F9CCCC",
        borderWidth: 1,
        type: "bar",
        yAxisID: "y-axis-count",
      },
      {
        label: "YoY Change (%) (14-18)",
        data: yoyChange_14_18,
        borderColor: "#0142B2", // Orange
        backgroundColor: "#0142B2",
        borderWidth: 2,
        pointBackgroundColor: "white",
        pointBorderColor: "black",
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.3,
        type: "line",
        yAxisID: "y-axis-yoy",
      },
      {
        label: "YoY Change (%) (22-24)",
        data: yoyChange_22_24,
        borderColor: "rgba(255, 99, 132, 1)", // Red
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderWidth: 2,
        pointBackgroundColor: "white",
        pointBorderColor: "black",
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.3,
        type: "line",
        yAxisID: "y-axis-yoy",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Employment & YoY Change (%) by Age Group (2018-2024)",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Year",
        },
      },
      "y-axis-count": {
        title: {
          display: true,
          text: "Employment Count",
        },
        beginAtZero: true,
        position: "left",
      },
      "y-axis-yoy": {
        title: {
          display: true,
          text: "Year-over-Year Change (%)",
        },
        beginAtZero: false,
        position: "right",
        ticks: {
          callback: function (value) {
            return value + "%"; // Adds % sign to YoY axis
          },
        },
        grid: {
          drawOnChartArea: false, // Prevents overlap with bar chart grid
        },
      },
    },
  };

  const downloadPDF = () => {
    const input = pdfRef.current;

    const originalWidth = input.style.width;
    input.style.width = "1100px";
    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(utahData, "PNG", 60, 4, 30, 30);
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22);

      pdf.link(50, 15, 60, 10, { url: "https://utahdata.org" });

      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString();
      pdf.setFontSize(12);
      pdf.text(`Downloaded on: ${formattedDate}`, 150, 295);

      pdf.setLineWidth(0.5);
      pdf.setDrawColor(0, 0, 0);
      pdf.line(10, 35, 200, 35);

      const headerHeight = 38;
      pdf.addImage(imgData, "PNG", 0, headerHeight, imgWidth, imgHeight);

      pdf.line(10, 260, 200, 260);

      const footerStartY = 265;
      pdf.addImage(utahData, "PNG", 33, footerStartY, 20, 20);
      pdf.setFontSize(10);
      pdf.setTextColor(0, 122, 255);
      pdf.text("Built by", 55, footerStartY + 10);

      pdf.addImage(bodex, "PNG", 68, footerStartY + 4, 44, 10);
      pdf.text("using", 112, footerStartY + 10);
      pdf.addImage(kpi, "PNG", 125, footerStartY, 20, 20);

      pdf.text(" 20250916.v3.198", 148, footerStartY + 10);

      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      pdf.save("csAndIt_table8.pdf");
      input.style.width = originalWidth;
    });
  };

  return (
    <div className="dashboard-container">
      <div ref={pdfRef} className="content-to-export">
        <div style={{ padding: "20px" }}>
          <h2>Employment & YoY Change (%) by Age Group (2018-2024)</h2>

          {/* Render Table */}
          <div style={{ overflowX: "auto", marginBottom: "20px" }}>
            <Table
              border="1"
              cellPadding="10"
              style={{ width: "100%", minWidth: "500px" }}
            >
              <thead>
                <tr>
                  <th>Year</th>
                  <th>Employment (14-18)</th>
                  <th>Employment (22-24)</th>
                  <th>YoY Change (14-18) %</th>
                  <th>YoY Change (22-24) %</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{row.year}</td>
                    <td>{row.age_14_18}</td>
                    <td>{row.age_22_24}</td>
                    <td
                      style={{
                        color: row.yoy_change_14_18 >= 0 ? "blue" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {row.yoy_change_14_18
                        ? row.yoy_change_14_18 + "%"
                        : "N/A"}
                    </td>
                    <td
                      style={{
                        color: row.yoy_change_22_24 >= 0 ? "blue" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {row.yoy_change_22_24
                        ? row.yoy_change_22_24 + "%"
                        : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Dual-Axis Bar + Line Chart */}
          <div
            style={{
              width: "90%",
              maxWidth: "900px",
              margin: "auto",
              overflowX: "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                minWidth: "600px",
                height: "400px",
                background: "#fff",
              }}
            >
              <Bar data={chartData} options={chartOptions} />
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="flex justify-center">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
        >
          <span>Download as PDF </span>
          <span>
            <img className="w-[2rem]" src={pdf} onClick={downloadPDF} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default CsAndItTable1;
